import { createContext, useContext } from "react";

export type RegisterContentContextType = {
  token: string;
  onRequestNDA: () => void;
  onRequestMeeting: () => void;
};

const RegisterContentContext = createContext<RegisterContentContextType>(
  {} as RegisterContentContextType
);

export const RegisterContentProvider = RegisterContentContext.Provider;

export function useRegisterContent() {
  return useContext(RegisterContentContext);
}
